import { useTranslation } from "react-i18next";
import Style from "./style";

export default function ProductCont({
  name = '',
  clients = '',
  workers = '',
  investments = '',
  imgSrc = '/assets/images/dashboard/tif-products/gold-bg.png',
  logo = '/assets/images/dashboard/tif-products/gold-logo.png',
}) {
  const { t } = useTranslation();
  return (
    <Style>
      <div className="image-cont flex-1" style={{ background: `url('${imgSrc}')` }}>
        <div className="mask" />
        <img className="product-logo" src={logo} alt={logo} />
      </div>

      <div className="info-cont flex-1">
        <div className="item">
          <label className="label flex-1">{t('Program')}</label>
          <label className="value">{name}</label>
        </div>

        <div className="item">
          <label className="label flex-1">{t('Clients')}</label>
          <label className="value">{clients}</label>
        </div>

        <div className="item">
          <label className="label flex-1">{t('Investments')}</label>
          <label className="value">{investments}</label>
        </div>

        <div className="item">
          <label className="label flex-1">{t('Workers')}</label>
          <label className="value">{workers}</label>
        </div>

      </div>
    </Style>
  );
}
